import axios from "axios";
import toastr from "toastr";
//import logger from "./logService";

axios.defaults.baseURL = process.env.REACT_APP_ROOT_URL;
let manage_pages = false;
axios.interceptors.response.use(null, error => {
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;
    let network_error = false;

    if(error.response)
    {
        if(error.response.data)
        {
            //console.log("httpService error.response.data", error.response.data);
            if(error.response.data.error)
            {
                if(error.response.data.error.message)
                {
                    // toastr.error(error.response.data.error.message);
                    //if(error.response.data.error.message.toString().includes("manage"))
                    //{
                    //console.log("HERE IS A NETWORK ERROR");
                    manage_pages = true;
                    //}
                    //alert(error.response.data.error.message);
                    //console.log("HERE manage_pages = true");
                }
            }
        }
        //console.log("httpService error.response", error.response);
    }

    else
    {
        //console.log("HERE");
        //console.log("HERE httpService error.toString()", error.toString());
        //console.log("HERE httpService this.props", error);
        if(error.toString().includes("Network Error"))
        {
            //console.log("HERE IS A NETWORK ERROR");
            network_error = true;
        }
        //else
        //{
        //    //console.log("HERE else", error);
        //}
        //console.log("HERE2");
    }

    if (!expectedError) {

        //console.log("httpService  window.location.pathname", window.location.pathname);

        if(network_error)
        {
            //console.log("error.response.status HERE manage_pages = true" , error.response.status);
            if(manage_pages)
            {
                //console.log("HERE manage_pages = true");
                toastr.info("Please, modify necessary permissions from Facebook and try again.");
            }
            else if(error.toString().includes("400"))
            {
                toastr.error("Bad request.");
            }
            else
            {
                //console.log("HERE manage_pages = false");
                //alert("Network error. Page will refresh... Please check your network connection if necessary.");
                window.location = window.location.pathname ? window.location.pathname : "/login";
            }
        }
        else
        {
            if(error.toString().includes("400"))
            {
                toastr.error("A bad request.");
            }
            else
            {
                alert("An unexpected error occurred.");
                window.location = "/login";
            }

        }

    }
    else
    {
        // console.log("httpService error.response.status", error.response.status);
    }

    return Promise.reject(error);
});

function setJwt(jwt) {
    axios.defaults.headers.common['authorization'] = jwt;
}

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    patch: axios.patch,
    delete: axios.delete,
    setJwt
};
